import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import classNames from 'classnames';
import { SelectInput as SparkSelect } from '@sabre/aven-spark';

export default class ControlledSelect extends Component {
    static displayName = 'ControlledSelect';

    static propTypes = {
        /** Any extra CSS classes for the component */
        className: PropTypes.string,
        /** adds a text label at the top of the select field */
        label: PropTypes.string,
        /** sets the selected option in the dropdown */
        value: PropTypes.string,
        /** sets the html 'name' attribute */
        name: PropTypes.string,
        /** html attribute */
        disabled: PropTypes.bool,
        /** html attribute */
        required: PropTypes.bool,
        /** populates the dropdown with label/value pairs */
        options: PropTypes.array,
        /** select behavior when selected value changes */
        onChange: PropTypes.func,
        /** an error message to eventually be shown */
        errorMessage: PropTypes.string
    };

    static renderMessage = errorMessage => <span className="spark-select__message">{errorMessage}</span>;
    static renderOptions = options => {
        return map(options, option => {
            const label = option.label || option.value;
            return (
                <option key={option.key} value={option.key}>
                    {label}
                </option>
            );
        });
    };

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this.sparkSelect = new SparkSelect(this.selectSpark);
    }

    render() {
        const { className, label, name, value, required, disabled, errorMessage, options, isDisabled } = this.props;
        const containerClass = classNames('spark-select', className, {
            'has-value': !!this.props.value
        });
        const selectAttributes = {
            required,
            disabled: disabled || isDisabled
        };
        const labelAttributes = errorMessage && errorMessage.length > 0 ? { 'data-error': true } : null;

        return (
            <label
                ref={ref => {
                    this.selectSpark = ref;
                }}
                className={containerClass}
                {...labelAttributes}
            >
                <select
                    ref={ref => {
                        this.selectInput = ref;
                    }}
                    className="spark-select__input"
                    value={value}
                    name={name}
                    onChange={() => this.onChange()}
                    {...selectAttributes}
                >
                    {!value && <option />}
                    {ControlledSelect.renderOptions(options)}
                </select>
                {label && <span className="spark-label">{label}</span>}
                {errorMessage && ControlledSelect.renderMessage(errorMessage)}
            </label>
        );
    }

    onChange() {
        const { onChange } = this.props;
        return onChange && onChange(this.selectInput.value);
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/sabre-spark-react-ex/select/ControlledSelect.js